import { Extension } from '@tiptap/core';

import { createCdiNudgeHighlightsPlugin } from './create-plugin';

export const CdiNudgeHighlights = Extension.create({
  name: 'cdiNudgeHighlights',

  addProseMirrorPlugins() {
    return [createCdiNudgeHighlightsPlugin()];
  },
});
